import React from 'react'
import ChannelStore from 'src/components/template/channel-store'

/**
 * Channel Store Landing Page
 * Showcases individual premium channels available for separate subscription
 */
const ChannelStorePage = (props) => {
  return (
    <ChannelStore
      location={props.location}
      lang="en"
      market="us"
      pageTitle="Fubo Channel Store - Watch more. Pay less."
      pageDescription="Access individual channels without a Fubo base plan."
    />
  )
}

export default ChannelStorePage
